export default {
  list: {
    pageTitle: {
      fullList: '全部商品',
      myShop:'我的商店',
    },
    containerTitle: {
      hotsale: '热门产品',
      myProduct:'我的产品',
    },
    addBtnHint1:'凡是选购过的商品都会自动成为你专属商店的商品',
    addBtnHint2:'赶快去首页选购吧！',
    loadMore:'加载更多',
    selectSuccess:'成功添加该商品至精选推介',
    removeConfirm:'确认从精选推介移除该商品吗？',
    noMoreProduct:'-已显示所有货物-'
  },
  detail: {
    shippingCost: '运费 ¥ 28 及附加关税',
    containerTitle: {
      description: '商品详情',
      feature: '商品特色'
    }
  },

}



// WEBPACK FOOTER //
// ./src/Product/langs/zh_cn/index.js